<template>
  <FullPage>
    <Webview>
      <Header title="修改密碼" :back="back"></Header>
      <div class="form _fill">
        <template v-for="(item, key) in form">
          <Control :passData="item" :update="update" :check="check"></Control>
          <!-- 忘記密碼 -->
          <template v-if="key === 'oldPassword'">
            <div class="forgetPwd"><span @click="toPage('forgetPassword')">忘記密碼</span></div>
          </template>
        </template>
      </div>
      <div class="wv_button">
        <div class="main_btn _main" @click="submit">儲存</div>
      </div>
    </Webview>
    <router-view />
  </FullPage>
</template>

<script>
export default {
  mixins: [
    require("@mix/form").default,
    require("../mixins/formData_ChangePassword").default
  ],
  data() {
    return {

    }
  },
  methods: {
    back() {
      this.$router.replace({ path: "/setting" });
    },
    toPage(type) {
      switch (type) {
        case "forgetPassword": this.$router.push({ path: "/setting/forgetPassword" }); break;
      }
    },
    submit() {
      this.checkAll();
      if (!this.isAllValid) return false;
    }
  }
}
</script>

<style lang="scss">
.form {
  padding: 1rem $main_P;
}
</style>